<template>
    <form-container v-if="dataObject" :headerText="title" breakpoint="smAndDown"
                    :width="900" :action="action" :valid-actions="['editMaL', 'editMaLAdmin']" @save="save()"
                    :header-sub-text="subtitle" :missingInputAlert="true"
                    :buttonOk="warningConfirmed?'Speichern':''">
        <spiel-bericht-edit-alert :warningConfirmed="warningConfirmed"
                    :data-object="dataObject" @confirmed="confirmWarning">
        </spiel-bericht-edit-alert>
        <div v-if="rules && warningConfirmed">
            <div>
                <v-row class="mx-0 px-4 mt-1 mb-2">
                    <v-col sm="3" cols="12" class="pl-0 pr-2">
                        <v-text-field v-model="dataObject.infos.ort" class="body-2" label="Austragungsort"
                                      :rules="[rules.required]" outlined dense hide-details >
                        </v-text-field>
                    </v-col>
                    <v-col sm="4" cols="12" class="pl-1 pr-2">
                        <v-text-field v-model="dataObject.infos.bahn" class="body-2" label="Bahnanlage"
                                      :rules="[rules.required]" outlined dense hide-details >
                        </v-text-field>
                    </v-col>
                    <v-col sm="3" cols="12" class="pl-1 pr-2">
                        <v-text-field v-model="dataObject.infos.stream" class="body-2"
                                      label="Link zum Stream"
                                      placeholder="muss mit 'https://' oder 'http://' beginnen"
                                      :rules="[rules.url]" outlined dense hide-details >
                        </v-text-field>
                    </v-col>
                    <v-col sm="2" class="px-1">
                        <tool-tip text="Spiel-Id für Streaming Link kopieren">
                            <v-btn block class="mx-0" @click="copyIdToClipboard()">
                                <v-icon>mdi-content-copy</v-icon>Spiel-id</v-btn>
                        </tool-tip>
                        <v-snackbar v-model="snack" color="success">
                            Die Spiel-ID wurde in die Zwischenablage kopiert.
                        </v-snackbar>
                    </v-col>
                </v-row>
            </div>
            <div class="px-7 pb-3 pt-5 borderTop">
                <v-row no-wrap>
                    <spiel-bericht-edit-ma-l-team :data-object="dataObject" class="pr-5"
                                                  :rules="rules" type="heim">
                    </spiel-bericht-edit-ma-l-team>
                    <spiel-bericht-edit-ma-l-team :data-object="dataObject" class="pl-5"
                                                  :rules="rules" type="gast">
                    </spiel-bericht-edit-ma-l-team>
                </v-row>
            </div>
            <div class=" borderBottom pt-2 pb-4 mb-3">
                <div class="px-4 subtitle-1 font-weight-bold mb-2">Schiedsrichter/in</div>
                <v-row class="mx-0 px-4">
                    <v-col cols="2" class="px-0">
                        <v-text-field v-model="dataObject.referee.lvId" class="body-2" label="LV"
                                      :rules="[rules.required]" outlined dense hide-details >
                        </v-text-field>
                    </v-col>
                    <v-col cols="3" class="pr-0">
                        <v-text-field v-model="dataObject.referee.nr" class="body-2" label="Nummer"
                                      :rules="[rules.required]" outlined dense hide-details >
                        </v-text-field>
                    </v-col>
                    <v-col cols="7" class="pr-0">
                        <v-text-field v-model="dataObject.referee.name" class="body-2" label="Name"
                                      :rules="[rules.required]" outlined dense hide-details >
                        </v-text-field>
                    </v-col>
                </v-row>
                <div v-if="dataObject.saison.freieSpieler" >
                    <div class="px-4 mt-3 subtitle-1 font-weight-bold mb-2">
                    Datenschutz frei Spieler</div>
                    <v-row class="mx-0 px-4">
                        <v-col class="pa-0">
                            <v-checkbox v-model="dataObject.saison.datenschutz" :rules="[rules.agreed]"
                                     color="primary" class="pt-0 mt-2 ml-2">
                                <template v-slot:label>
                                    <span class="body-2">alle freien Spieler haben der Veröffentlichung ihres
                                        Namens im Ergebnisdienst auf der ÖSKB Homepage zugestimmt</span>
                                </template>
                            </v-checkbox>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>
        <!--<v-btn @click="dataObject.setZufallMaL()">Test Basisdaten</v-btn>-->
        <error-msg :error="error"></error-msg>
    </form-container>
</template>

<script>
    import FormContainer from "../../../../components/form/formContainer";
    import ErrorMsg from "../../../../components/elements/errorMsg";
    import {Spiel} from "../../../../services/data/spiel";
    import {FormRules} from "../../../../services/formRules";
    import SpielBerichtEditMaLTeam from "./spielBerichtEditMaLTeam";
    import SpielBerichtEditAlert from "./spielBerichtEditAlert";
    import ToolTip from "../../../../components/elements/toolTip";
    import FirebaseRead from "@/services/database/firebaseRead";

    export default {
        components: {
            ToolTip,
            SpielBerichtEditAlert,
            SpielBerichtEditMaLTeam,
            ErrorMsg,
            FormContainer},
        name: "spiel-bericht-edit-ma-l",
        props: ['currentData', 'action'],
        computed: {
            title(){ return this.$vuetify.breakpoint.xsOnly ?
                'Mannschaftsaufstellungsliste':'Mannschaftsaufstellungsliste (MaL)'},
            subtitle(){ return this.dataObject.getSubTitle(); },
            user() { return this.$store.state.user; }
        },
        data: () => ({
            snack: false,
            rules: null,
            dataObject: null,
            error: '',
            warningConfirmed: false,
        }),
        created(){
            console.log ("CREATED MaL EDIT!!!");
            this.init()
        },
        methods: {
            async init(){
                this.rules = new FormRules();
                this.dataObject = new Spiel();
                this.dataObject.setFromDataObject(this.currentData);
                if ( this.dataObject.partien[1].heim.bahn === 0 ) {
                    const vereinsDatenBlatt = await FirebaseRead.readSingleDoc('vereinsdatenblaetter', this.currentData.heim.vereinsNr )
                    this.dataObject.setBahnenFromVereinsdatenblatt(vereinsDatenBlatt)
                }
                if ( this.currentData.stream ) { this.dataObject.stream = this.currentData.stream }
            },
            copyIdToClipboard(){
                navigator.clipboard.writeText(this.currentData.id);
                this.snack = true;
            },
        // multiuser alert
            confirmWarning(){
                this.warningConfirmed = true;
            },
        //save
            async save(){
            // create update document
                // base data
                    this.dataObject.local.documentUpdates = {
                        ['infos.ort']: this.dataObject.infos.ort,
                        ['infos.bahn']: this.dataObject.infos.bahn,
                        ['infos.stream']: this.dataObject.infos.stream,
                        ['heim.captain']: this.dataObject.heim.captain,
                        ['gast.captain']: this.dataObject.gast.captain,
                        referee: this.dataObject.referee,
                        //['heim.ersatzSpieler']: this.dataObject.heim.ersatzSpieler,
                        //['gast.ersatzSpieler']: this.dataObject.gast.ersatzSpieler,
                    };
                // spieler und Bahnen
                    Object.keys(this.dataObject.partien).forEach( (partieId) => {
                        const partie = this.dataObject.partien[partieId];
                        const keyHeim = 'partien.' + partieId + '.heim';
                        const keyGast = 'partien.' + partieId + '.gast';
                        this.dataObject.local.documentUpdates[keyHeim + '.spieler'] = partie.heim.spieler;
                        this.dataObject.local.documentUpdates[keyGast + '.spieler'] = partie.gast.spieler;
                        this.dataObject.local.documentUpdates[keyHeim + '.bahn'] = partie.heim.bahn;
                        this.dataObject.local.documentUpdates[keyGast + '.bahn'] = partie.gast.bahn;
                    });
                // ersatzspieler
                    this.setErsatzspielerInDocumentUpdates('heim');
                    this.setErsatzspielerInDocumentUpdates('gast');
                // data protection
                    if ( this.dataObject.saison.freieSpieler ) {
                        this.dataObject.local.documentUpdates['saison.datenschutz'] =
                            this.dataObject.saison.datenschutz;
                    }
                // stream
                    if ( this.dataObject.infos.stream && !this.dataObject.stream ) {
                        this.dataObject.local.documentUpdates.stream = {
                            auto: true,
                            dg: 1,
                            switch: true,
                        }
                    }
            // save
                this.$store.state.local.loader = true;
                let reply = await this.dataObject.saveEdited('spiel_edit');
                if ( reply.successful ) {
                    // return pure data object
                        this.emitDataToList();
                    // close window
                        window.history.back();
                } else {
                    this.error = this.dataObject.getDBErrorText(reply.content);
                }
                this.$store.state.local.loader = false;
            },
                emitDataToList(){
                    let spiel = this.dataObject.getDbObject();
                    spiel.id = this.dataObject.id;
                    this.$emit('updated', spiel);
                },
                setErsatzspielerInDocumentUpdates(type){
                    Object.keys(this.dataObject[type].ersatzSpieler).forEach( (spielerId) => {
                        const ersatzSpieler = this.dataObject[type].ersatzSpieler[spielerId];
                        const keyBasis = type + '.ersatzSpieler.'+spielerId;
                        this.setData(keyBasis, 'id', ersatzSpieler, '');
                        this.setData(keyBasis, 'name', ersatzSpieler, '');
                        this.setData(keyBasis, 'nationalitaet', ersatzSpieler, '');
                        this.setData(keyBasis, 'akHJ', ersatzSpieler, '');
                        this.setData(keyBasis, 'akJahr', ersatzSpieler, '');
                        if ( this.dataObject.saison.freieSpieler ) {
                            this.setData(keyBasis, 'frei', ersatzSpieler, false);
                            this.setData(keyBasis, 'hatPass', ersatzSpieler, false);
                            this.setData(keyBasis, 'passNr', ersatzSpieler, '');
                            this.setData(keyBasis, 'vorname', ersatzSpieler, '');
                            this.setData(keyBasis, 'nachname', ersatzSpieler, '');
                        }
                    });
                },
                    setData(keyBasis, field, ersatzSpieler, valueUndefined){
                        this.dataObject.local.documentUpdates[keyBasis + '.' + field] =
                            ersatzSpieler[field] === undefined ? valueUndefined : ersatzSpieler[field];
                    }
        },
    }
</script>

<style scoped>
    .borderTop {border-top: solid 1px lightgrey;}
    .borderBottom {border-bottom: solid 1px lightgrey;}
</style>